import { CanMatchFn } from '@angular/router';

export const publicProfileGuard: CanMatchFn = (route, segments) => {
  const reservedSlugs = ['login', 'register', 'verify-otp', 'event', 'contact', 'terms-of-use', 'privacy-policy'];
  return !reservedSlugs.includes(segments.at(-1)?.path ?? ``);
};
